export default __webpack_public_path__ + "static/media/greenVegLogo.ae4ad282.png";